import { useMemo } from "react";
import Select from "react-select";
import { CommonInputProps } from ".";
import { InputContainer, roomCustomStyles } from "./InputStyles";
import { useDispatch, useSelector } from "../../../../../store/store";
import {
    getRooms,
    getRoomValue,
    isDayDisabled,
    setRoom,
} from "../../../../../store/data";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

interface Props extends CommonInputProps {
    roomId: number;
}
export const defaultValue = (t: TFunction<"translation"> | undefined) => {
    return {
        value: -1,
        label: t && t("no_room_selected"),
    };
};

const RoomSelect = ({ roomId, day, consultationIndex }: Props) => {
    const dispatch = useDispatch();
    const rooms = useSelector(getRooms);
    const roomValue = useSelector(getRoomValue(roomId));
    const dayDisabled = useSelector(isDayDisabled(day));
    const { t } = useTranslation();

    const handleChange = (newValue: unknown) => {
        const value = newValue as { value: number; label: string };
        dispatch(
            setRoom({
                day,
                consultationIndex,
                roomId: value.value,
            })
        );
    };

    const options = useMemo(
        () => [
            defaultValue,
            ...rooms
                .map((room) => ({ label: room.name, value: room.id }))
                .sort((a, b) => a.label.localeCompare(b.label)),
        ],
        [rooms]
    );

    return (
        <InputContainer>
            <Select
                isDisabled={dayDisabled}
                defaultValue={roomId}
                name="colors"
                options={options}
                className="basic-multi-select"
                classNamePrefix="select"
                hideSelectedOptions={false}
                value={roomValue}
                onChange={handleChange}
                placeholder={defaultValue(t).label}
                openMenuOnClick
                menuPlacement={day.index < 5 ? "bottom" : "top"}
                styles={roomCustomStyles}
                maxMenuHeight={150}
            />
        </InputContainer>
    );
};

export default RoomSelect;
